var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('VueTimeline',{attrs:{"timeline-items":_vm.dataForTimeline,"individualClasses":true}}),(_vm.showNumber <= _vm.dataForTimeline.length)?_c('button',{on:{"click":_vm.incrementCount}},[_vm._v("Show More")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }